<template>
  <vs-row vs-type="flex" vs-align="flex-end" class="mb-1" >
    <vs-col vs-w="10">
      <h5 v-if="count && count > 0">{{title}} ({{count}})</h5>
      <h5 v-else>{{title}}</h5>
    </vs-col>

    <vs-col vs-type="flex" vs-justify="flex-end" vs-w="2">
      <slot></slot>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: false,

    },
  },
}
</script>
